import { render, staticRenderFns } from "./pick-list.vue?vue&type=template&id=481de2d6&scoped=true"
import script from "./pick-list.vue?vue&type=script&lang=js"
export * from "./pick-list.vue?vue&type=script&lang=js"
import style0 from "./pick-list.vue?vue&type=style&index=0&id=481de2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481de2d6",
  null
  
)

export default component.exports